import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AllocationViewFacade } from '../../allocation-view/allocation-view.facade';
import { AllocationViewFilterProfileModel, AllocationViewProfile } from '../models';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { AllocationViewProfileItemFacade } from '../item/allocation-view-profile-item.facade';
import { AllocationViewFilterProfileItemFacade } from '../filter';
import { getFiltersCount } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewDefaultProfileGuard {
  constructor(
    private allocationViewProfileItemFacade: AllocationViewProfileItemFacade,
    private allocationViewFilterProfileItemFacade: AllocationViewFilterProfileItemFacade,
    private allocationViewFacade: AllocationViewFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.allocationViewProfileItemFacade.getDefaultProfile();

    this.allocationViewProfileItemFacade.defaultProfile$
      .pipe(filter(Boolean), take(1))
      .subscribe((defaultProfile: AllocationViewProfile) => {
        if (defaultProfile?.filterProfileId) {
          this.allocationViewProfileItemFacade.getFilterProfile(defaultProfile.filterProfileId);
          this.allocationViewProfileItemFacade.filterProfile$
            .pipe(filter(Boolean), distinctUntilChanged())
            .subscribe((filterProfile: AllocationViewFilterProfileModel) => {
              if (getFiltersCount(filterProfile.filters) > 0) {
                const { timeFrame: _timeFrame, ...withoutTimeFrameFilter } = filterProfile.filters;
                this.allocationViewFilterProfileItemFacade.setFilterProfile(filterProfile);
                this.allocationViewFacade.setFilters(withoutTimeFrameFilter);
              }
            });
        }

        this.allocationViewFacade.setProfile(defaultProfile);
      });

    return of(true);
  }
}
